
getBundleGiftJson();

function getBundleGiftJson() {
	var bundleGiftData = theme.settings.bundleGiftData;
	let bundleGiftJson = {};
	if (bundleGiftData) {
		bundleGiftData.forEach(item => {
			const giftId = item.gift.split('/').pop();
			const productIds_arr= Array.isArray(item.products) ? item.products : (item.products != null ? [item.products] : []);
			const productIds = productIds_arr.map(product => product.split('/').pop());
			if (productIds.length > 0) {
				bundleGiftJson[giftId] = productIds;
			}
		});
	}

	if (Object.keys(bundleGiftJson).length > 0) {
		window.bundleGiftJson = bundleGiftJson;
	}
}
